import React from 'react'
import TopUpModal from './components/TopUpModal'; // путь поправь если нужно

const ProfileDeposit = () => {
  return (
    <div><TopUpModal /></div>
  )
}

export default ProfileDeposit